<template>
    <div name="card" class="card" v-if="reception_number != ''">
        <CardInput class="mobile-area" 
            :reception_number="reception_number"
        />
    </div>
</template>

<script>

import CardInput from '@/pages/card/CardInput';

export default {
    name: 'card',
    data: function()
    {
        return {
            selectedCardIndex: -1,
            user_id: '',
            partner_name: '',
        }
    },  
    mounted: function()
    {
        this.reception_number = this.$route.query.reception_number;
        if(this.reception_number == '' || this.reception_number == undefined || this.reception_number == null)
        {
            this.reception_number = '';
            alert("잘못된 링크입니다.")
        }
    },
    components: {
        CardInput
    },
    data: function()
    {
        return {
            state: 0,
            reception_number: ''
        }
    },  
    methods: {
        addCard: function()
        {
            this.selectedCardIndex = -1;
            this.state = 2;
        },
        updateCard: function(card_index)
        {
            this.selectedCardIndex = card_index;
            this.state = 2;
        },  
        login: function(user_id, partner_name, state)
        {
            this.user_id = user_id;
            this.partner_name = partner_name;
            this.selectedCardIndex = -1;
            this.state = state;
        }
    }
}
</script>

<style scoped>
    .card {

        display: flex;
        flex-direction: row; /* 가로 방향으로 항목 정렬 */
        justify-content: center; /* 가운데 정렬 */
        align-items: center;
        background: #d0d4d9;
        height: 100vh;
    }
    .mobile-area {
        width: 100%;
        max-width: 100%;
        overflow: hidden;
    }

@media (min-width: 960px) {
    .card {
        display: flex;
        flex-direction: row; /* 가로 방향으로 항목 정렬 */
        justify-content: center; /* 가운데 정렬 */
        align-items: center;
        background: #d0d4d9;
        height: 100vh;
    }
    .mobile-area {
        display: flex; /* 모바일 영역 보임 */
        width: 480px; /* 너비 고정 */
        max-width: 480px; /* 최대 너비 설정 */
        justify-content: flex-end;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/Card.vue